// extracted by mini-css-extract-plugin
module.exports = {"events_list":"EventsList_events_list__XyonC"};